import { userRoom } from './reducer';

export const {
  clearUserRoom,
  setLatestUserRoomState,
  setSelectedUserRoomState,
  setIsLoadingRoom,
  setIsActiveRound,
} = userRoom.actions;
